import * as React from 'react'
import { GraphQLClient } from 'graphql-request'
import { getSdk, Sdk } from '../../generated/graphql'

export type BackendClient = Sdk

export type GraphqlRequestContextType = {
  backendClient: BackendClient
}

const GraphqlRequestContext = React.createContext<GraphqlRequestContextType>({} as any)

type Props = {
  graphqlClient: {
    backend: GraphQLClient
  }
}

export const GraphqlRequestContextProvider: React.FC<Props> = ({ children, graphqlClient }) => {
  /**
   * NOTE: カイゼンメモ
   * getSdkの引数にmiddlewareを渡せる模様。
   * Sentry通知等のエラーハンドリングに使えそう
   * https://www.graphql-code-generator.com/docs/plugins/typescript-graphql-request#simple-request-middleware
   */
  const backendClient = getSdk(graphqlClient.backend)
  return <GraphqlRequestContext.Provider value={{ backendClient }}>{children}</GraphqlRequestContext.Provider>
}

export const useGraphqlRequestContext = () => React.useContext(GraphqlRequestContext)
